import { SelectionChangedEvent } from "ag-grid-community";
import { customDispatchEvent, E_Custom_Dispatch_Event, E_Type_Of_Event } from "helpers/Events";
import _ from "lodash";
import { INITIAL_PROPOSAL_ENQUIRY_HEADER_COL_DEF, transferRowData } from "presentation/constant/ProposalEnquiry/ProposalEnquiryHeaderColumnDefinition";
import { useProposalEnquiryVM } from "presentation/hook/ProposalEnquiry/useProposalEnquiryVM";
import { useProposalEnquiryTracked } from "presentation/store/ProposalEnquiry/ProposalEnquiryProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { useCallback, useEffect, useRef, useState } from "react";
import { IconButton, Loader } from "veronica-ui-component/dist/component/core";


export const ProposalEnquiryTablePanel = () => {
    const [proposalEnquiryState] = useProposalEnquiryTracked();
    const isShowRightCriteriaPanel = proposalEnquiryState.isShowRightCriteriaPanel;
    const proposalEnquiryVM = useProposalEnquiryVM();
    let gridRef: any = useRef();
    const [showOverlay, setShowOverlay] = useState<boolean>(false);
    const tableDoubleClicked = (data: any) => {
        customDispatchEvent(E_Type_Of_Event.MODAL_EVENT, E_Custom_Dispatch_Event.MODAL_FULL_SCREEN_MODE, { isFullScreen: true, className: 'proposal-search-modal' });
        proposalEnquiryVM.openProposalDetail(data.data);
    }

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        proposalEnquiryVM.updateSelectedRowsActivate(selectedRows);
    }, [proposalEnquiryVM])

    const calculatePosition = useCallback(() => {
        const pDiv = document.querySelector(`.charge-data-box.filter-preview`);
        if (pDiv) {
            let currentElement = pDiv as HTMLElement;
            let width = currentElement.clientWidth - 22;
            let height = currentElement.clientHeight - 2;
            return { width: width, height: height };
        } else {
            return {};
        }
    }, [])

    useEffect(() => {
        setShowOverlay(proposalEnquiryState.isSearchLoading || (!proposalEnquiryState.isSearchLoading &&
            proposalEnquiryState.proposals && proposalEnquiryState.proposals.length) ? false : true);

        if (gridRef.current?.gridRef.current && !proposalEnquiryState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [proposalEnquiryState.isSearchLoading, proposalEnquiryState.proposals]);

    return <div className={`table-ag-gird im-charge-data-search-table-panel ag-theme-alpine`} style={{ position: 'relative' }}>
        {(proposalEnquiryState.isDoing) && <Loader Indicator="Spinner" size="Medium" style={{ ...calculatePosition(), position: 'fixed', backgroundColor: 'rgba(255,255,255,0.5)' }} />}
        <div className={`im-charge-data-search-table-panel-content ag-theme-alpine`}>
            <NbisTable
                id='proposal-enquiry-table'
                columns={INITIAL_PROPOSAL_ENQUIRY_HEADER_COL_DEF?.slice()}
                cacheBlockSize={30}
                isNewColumnSetting={true}
                isScrollHighlighted={true}
                showPaginator={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                showUploadIcon={true}
                gridHeight="customHeight"
                customHeight={"calc(100% - 25px)"}
                onRowDoubleClick={(e: any) => tableDoubleClicked(e)}
                selectionMode={true}
                rowSelection={"multiple"}
                isRowHighligted={true}
                suppressRowClickSelection={false}
                handleSelectionChanged={handleSelectionChange}
                rowHeight={28}
                rowBuffer={20}
                ref={gridRef}
                data={!_.isEmpty(proposalEnquiryState.proposals) ? transferRowData(proposalEnquiryState.proposals ?? []) : null}
                autoMarginLeft={true}
                entrypoint={'proposalEnquiry'}
                mustRefresh={true}
                showDefaultOverlayNoRowsTemplate={showOverlay}

                columnSettingIconList={[
                    <>
                        <IconButton fileName={isShowRightCriteriaPanel ? "Icon-angle-left" : "Icon-angle-right"} size="medium" toolTipText={isShowRightCriteriaPanel ? "Close Right Panel" : "Open Right Panel"} toolTipArrow={false} onClick={proposalEnquiryVM.onHideRightCriteriaPanel} />
                    </>
                ]}
            />
        </div>
    </div>;
}